import { render, staticRenderFns } from "./TwButton.vue?vue&type=template&id=fb57ee20"
import script from "./TwButton.vue?vue&type=script&lang=js"
export * from "./TwButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports